import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    precustomerData: {}
}

const precustomerSlice = createSlice({
    name: 'precustomer',
    initialState,
    reducers: {
        updatePrecustomer: (state, action) => {
            state.precustomerData = {...state.precustomerData, ...action.payload} 
        },
        updatePreCustomerData: (state, action) => {
            state.precustomerData = action.payload  
        }
    }
})

export default precustomerSlice.reducer
export const {updatePrecustomer, updatePreCustomerData} = precustomerSlice.actions